<template>
  <div class="typeahead-list">
    <div class="typeahead-list__input-container">
      <md-input
        id="autocomplete-input"
        v-model="query"
        :disabled="disabled || null"
        :debounce="0"
        :only-regular-characters="onlyRegularCharacters"
        @focus="onInputFocus($event)"
        @blur="onInputBlur($event)"
        @keydown.prevent.enter="inferItem"
        @keydown.tab="handleTab"
        @keydown.delete="requestLastItemDeletion"
        @keydown.prevent.up="highlightItem('up')"
        @keydown.prevent.down="highlightItem('down')"
        @keydown.prevent.esc="closeList"
        @keydown="charHandler"
        data-hj-allow
        tabindex="0"
        autocomplete="off"
        class="typeahead-list__input"
        :class="{ 'typeahead-list__input--with-hint': showSearchHint }"
        ref="input"
      >
      </md-input>
      <md-icon v-if="showSearchHint && !showArrowDown" class="typeahead-list__search-hint" :mdSvg="mdiMagnify" />
    </div>

    <md-progress v-if="loading" md-indeterminate key="stateLoading"></md-progress>
    <md-list
      class="typeahead-list__item-list"
      :class="{
        'typeahead-list__item-list--loading': loading,
        'typeahead-list__item-list--active': !loading && itemListVisible,
      }"
      ref="list"
    >
      <md-list-item
        v-if="(addNewItem && query.length > 0 && !queryInItemList) || (softList && query.length < minChars)"
        @click="createItem"
        @mousedown="handleItemMouseDown"
        @mouseup="handleItemMouseUp"
        @keydown.prevent.up="highlightItem('up')"
        @keydown.prevent.down="highlightItem('down')"
        @keydown.prevent.esc="applyInputFocus"
        :class="{ 'md-highlighted': highlighted === itemList.length }"
      >
        <slot name="desktopCreate" :query="query" :queryInItemExcludedList="queryInItemExcludedList"></slot>
      </md-list-item>
      <template v-if="grouped">
        <template v-for="item in itemList" :key="item.title">
          <md-list-item @keydown.prevent.esc="closeList">
            <span class="title">{{ item.title }}</span>
          </md-list-item>
          <md-list-item
            v-for="(value, index) in filterSelectedItems(item.values)"
            @click="selectItem(value)"
            @mousedown="handleItemMouseDown"
            @mouseup="handleItemMouseUp"
            @keydown.prevent.up="highlightItem('up')"
            @keydown.prevent.down="highlightItem('down')"
            @keydown.prevent.esc="closeList"
            :class="{ 'md-highlighted': highlighted === index }"
            :key="getId(value)"
          >
            <slot name="desktopItem" :item="value" :formatted="loading ? getText(value) : formatText(value)"></slot>
          </md-list-item>
          <md-list-item v-if="emptyValuesMessage && !filterSelectedItems(item.values)?.length">
            <span class="empty-state">{{ emptyValuesMessage }}</span>
          </md-list-item>
          <md-list-item
            v-if="item.pagination && item.pagination.currentPage < item.pagination.totalPages"
            @mousedown="handleItemMouseDown"
            @mouseup="handleItemMouseUp"
            @click="getMoreItems(item)"
          >
            <span>...</span>
          </md-list-item>
        </template>
      </template>
      <md-list-item
        v-else
        v-for="(item, index) in unselectedItems"
        @click="selectItem(item)"
        @mousedown="handleItemMouseDown"
        @mouseup="handleItemMouseUp"
        @keydown.prevent.up="highlightItem('up')"
        @keydown.prevent.down="highlightItem('down')"
        @keydown.prevent.esc="closeList"
        :class="{ 'md-highlighted': highlighted === index }"
        :key="getId(item)"
      >
        <slot name="desktopItem" :item="item" :formatted="loading ? getText(item) : formatText(item)"></slot>
      </md-list-item>
    </md-list>
  </div>
</template>

<script src="./tdlTypeaheadList.mjs"></script>
<style src="./tdlTypeaheadList.scss" lang="scss"></style>
